import React from 'react'

import UserForm from 'components/User/UserForm'
import useUserContext from 'components/User/useUserContext'

const UserProfile = ({history}) => (
  <UserForm
    initialValue={useUserContext().user}
    history={history}
    existingUser
  />
)

export default UserProfile
